import {css, StyleSheet} from 'aphrodite';
import React from 'react';

interface FilterFormSkeletonNodeLayoutProps {
  nodeGrid: Array<Array<JSX.Element>>; // One array for each row in the layout
}

const FilterFormSkeletonNodeLayout: React.SFC<FilterFormSkeletonNodeLayoutProps> = (
  props: FilterFormSkeletonNodeLayoutProps
): JSX.Element => (
  <div className={css(styles.wrapper)}>
    {props.nodeGrid.map((nodeGridItemRow, rowIndex) => (
      <div className={css(styles.nodeGridRow)} key={rowIndex}>
        {nodeGridItemRow.map((nodeGridItem, itemIndex) => (
          <span className={css(styles.nodeGridItem)} key={itemIndex}>
            {nodeGridItem}
          </span>
        ))}
      </div>
    ))}
  </div>
);

const styles = StyleSheet.create({
  wrapper: {
    padding: 10,
  },
  nodeGridRow: {
    display: 'flex',
    margin: -6,
  },
  nodeGridItem: {
    flexGrow: 1,
    flexBasis: 0,
    padding: 6,
  },
});

export default FilterFormSkeletonNodeLayout;
